const GraphQLForm = require('app/graphql/Form');

class Form extends GraphQLForm {

    defaultOptions(){
        var options = {
            'mutationType': 'SubmitRestaurant',
            'copyMode': false,
            'restaurant': {
                'id,': '',
                'siren': '',
                'name': '',
                'lastName': '',
                'firstName': '',
                'address': '',
                'addressComplement': '',
                'postalCode': '',
                'city': '',
                'billingStatus': 1,
                'billingPeriods': [],
                'seller':{
                    'id': null,
                },
                'applicationStatus': 1,
                'analyseDisplayMode': 1,
                'orderType': 1,
                'orderLimit': 1,
                'orderByMailStatus': 1,
                'type': '',
                'preset': '',
                'email': '',
                'phone': '',
                'info': {
                    'website': '',
                    'linkedin': '',
                    'twitter': '',
                    'facebook': '',
                    'instagram': '',

                },
            },
            'sellers': [],
        };
        return Object.assign(super.defaultOptions(),options);
    }

    initialize() {
        var self = this;

        this.restaurant = this.settings.restaurant;
        this.sellers = this.settings.sellers;

        this.buildForm();

        super.initialize();
    }

    getRestaurant(){
        return this.restaurant;
    }

    getForm(){
        return this.$form;
    }

    buildForm(){

        this.$btnSubmit = $('<button/>')
        .attr('type','submit')
        .addClass('btn btn-success');

        if(this.restaurant.id){
            if(this.isCopy()){
                this.$btnSubmit.append(window.translate('app.restaurant.copy.submit.label'));
            }else{
                this.$btnSubmit.append(window.translate('app.restaurant.show.tabs.info.infosForm.submit.label'));
            }
        }else{
            this.$btnSubmit.append(window.translate('app.restaurant.create.submit.label'));
        }

        this.$form = $('<form/>')
        .addClass('restaurant-info-form')
        .append(
            $('<div/>')
            .addClass('row')
            .append(this.buildGeneralCol())
            .append(this.buildBillingCol())
            .append(this.buildContactCol())
            .append(
                $('<div/>')
                .addClass('d-flex justify-content-center')
                .append(this.$btnSubmit)
            )
        );

        return this.$form;
    }

    getFields(){
        let fields = super.getFields();
        fields.push('restaurant { id }');
        return fields;
    }
    
    getVariables(){
        let variables = {};

        if(this.isCopy()){
            variables.copyFrom = {
                'value': this.restaurant.id,
                'type': 'Int'
            }

        }else if(this.restaurant.id){
            variables.restaurant = {
                'value': this.restaurant.id,
                'type': 'Int'
            }
        }

        return variables;
    }

    isCopy(){
        return this.settings.copyMode;
    }

    buildGeneralCol(){
        let $col = $('<div/>')
        .addClass('col-4 p-2');

        let $box = $('<div/>')
        .addClass('white-box')
        .appendTo($col);

        //LABEL
        let $label = $('<h3/>')
        .addClass('box-title')
        .append(window.translate('app.restaurant.show.tabs.info.generalForm.label'))
        .appendTo($box);

        let siren = this.restaurant.siren;
        let name = this.restaurant.name;
        let lastName = this.restaurant.lastName;
        let firstName = this.restaurant.firstName;
        let address = this.restaurant.address;
        let postalCode = this.restaurant.postalCode;
        let city = this.restaurant.city;
        if(this.isCopy()){
            siren = '';
            name = '';
            lastName = '';
            firstName = '';
            address = '';
            postalCode = '';
            city = '';
        }

        //FIELD siren
        let $sirenLabel = $('<label/>')
        .attr('for','siren')
        .append(window.translate('app.restaurant.show.tabs.info.generalForm.siren.label'));
        this.$inputSiren = $('<input/>')
        .attr('type','text')
        .attr('name','siren')
        .addClass('form-control')
        .val(siren);
        $box.append(
            $('<div/>')
            .addClass('form-group')
            .append($sirenLabel)
            .append(this.$inputSiren)
        )

        //FIELD name
        let $nameLabel = $('<label/>')
        .attr('for','name')
        .append(window.translate('app.restaurant.show.tabs.info.generalForm.name.label'));
        this.$inputName = $('<input/>')
        .attr('type','text')
        .attr('name','name')
        .addClass('form-control')
        .attr('required','required')
        .val(name);
        $box.append(
            $('<div/>')
            .addClass('form-group')
            .append($nameLabel)
            .append(this.$inputName)
        )

        //FIELD lastName
        let $lastNameLabel = $('<label/>')
        .attr('for','lastName')
        .append(window.translate('app.restaurant.show.tabs.info.generalForm.lastName.label'));
        this.$inputLastName = $('<input/>')
        .attr('type','text')
        .attr('name','lastName')
        .addClass('form-control')
        .attr('required','required')
        .val(lastName);
        $box.append(
            $('<div/>')
            .addClass('form-group')
            .append($lastNameLabel)
            .append(this.$inputLastName)
        )

        //FIELD firstName
        let $firstNameLabel = $('<label/>')
        .attr('for','firstName')
        .append(window.translate('app.restaurant.show.tabs.info.generalForm.firstName.label'));
        this.$inputFirstName = $('<input/>')
        .attr('type','text')
        .attr('name','firstName')
        .addClass('form-control')
        .attr('required','required')
        .val(firstName);
        $box.append(
            $('<div/>')
            .addClass('form-group')
            .append($firstNameLabel)
            .append(this.$inputFirstName)
        )

        //FIELD address
        let $addressLabel = $('<label/>')
        .attr('for','address')
        .append(window.translate('app.restaurant.show.tabs.info.generalForm.address.label'));
        this.$inputAddress = $('<input/>')
        .attr('type','text')
        .attr('name','address')
        .addClass('form-control')
        .val(address);
        $box.append(
            $('<div/>')
            .addClass('form-group')
            .append($addressLabel)
            .append(this.$inputAddress)
        )

        //FIELD addressComplement
        let $addressComplementLabel = $('<label/>')
        .attr('for','addressComplement')
        .append(window.translate('app.restaurant.show.tabs.info.generalForm.addressComplement.label'));
        this.$inputAddressComplement = $('<input/>')
        .attr('type','text')
        .attr('name','addressComplement')
        .addClass('form-control')
        .val(this.restaurant.addressComplement);
        $box.append(
            $('<div/>')
            .addClass('form-group')
            .append($addressComplementLabel)
            .append(this.$inputAddressComplement)
        )

        //FIELD postalCode
        let $postalCodeLabel = $('<label/>')
        .attr('for','postalCode')
        .append(window.translate('app.restaurant.show.tabs.info.generalForm.postalCode.label'));
        this.$inputPostalCode = $('<input/>')
        .attr('type','text')
        .attr('name','postalCode')
        .addClass('form-control')
        .val(postalCode);
        $box.append(
            $('<div/>')
            .addClass('form-group')
            .append($postalCodeLabel)
            .append(this.$inputPostalCode)
        )

        //FIELD city
        let $cityLabel = $('<label/>')
        .attr('for','city')
        .append(window.translate('app.restaurant.show.tabs.info.generalForm.city.label'));
        this.$inputCity = $('<input/>')
        .attr('type','text')
        .attr('name','city')
        .addClass('form-control')
        .val(city);
        $box.append(
            $('<div/>')
            .addClass('form-group')
            .append($cityLabel)
            .append(this.$inputCity)
        );

        return $col;
    }

    buildBillingCol(){
        let $col = $('<div/>')
        .addClass('col-4 p-2');

        let $box = $('<div/>')
        .addClass('white-box')
        .appendTo($col);

        this.buildBillingInputs($box);
        this.buildSoftwareInputs($box);


        return $col;
    }

    buildBillingInputs($box){


        let $labelBilling = $('<h3/>')
        .addClass('box-title')
        .append(window.translate('app.restaurant.show.tabs.info.billingForm.label'))
        .appendTo($box);

        //FIELD billingStatus
        let $billingStatusLabel = $('<label/>')
        .attr('for','billingStatus')
        .append(window.translate('app.restaurant.show.tabs.info.billingForm.billingStatus.label'));
        let values = [1,2];
        let $billingStatusContainer = $('<div/>')
        .addClass('row');
        for(var v in values){
            let value = values[v];
            let label = window.translate('app.restaurant.show.tabs.info.billingForm.billingStatus.value.'+value);

            let $inputRadio = $('<input/>')
            .attr('id','billingStatus'+value)
            .attr('type','radio')
            .attr('name','billingStatus')
            .val(value);

            if(value == this.restaurant.billingStatus){
                $inputRadio.attr('checked','checked');
            }

            let $labelRadio = $('<label/>')
            .attr('for','billingStatus'+value)
            .append(label);

            let $inputContainer = $('<div/>')
            .addClass('col')
            .append($inputRadio)
            .append(' ')
            .append($labelRadio);

            $billingStatusContainer.append($inputContainer);
        }
        $box.append(
            $('<div/>')
            .addClass('form-group')
            .append($billingStatusLabel)
            .append($billingStatusContainer)
        );

        //FIELD billingPeriods
        let $template = $('<div/>')
        .addClass('row')
        .addClass('restaurant-billingform-billingperiod-container');
        let $beginSelect = $('<select/>')
        .attr('name','billingPeriods[][begin]');
        let $endSelect = $('<select/>')
        .attr('name','billingPeriods[][end]');
        let $levySelect = $('<select/>')
        .attr('name','billingPeriods[][levy]');

        for(var i=0; i <=31; i++){
            let label = i == 0 ? '-' : i;
            let value = i == 0 ? '' : i;
            $beginSelect.append(
                $('<option/>')
                .attr('value',value)
                .append(label)
            );
            $endSelect.append(
                $('<option/>')
                .attr('value',value)
                .append(label)
            );
            $levySelect.append(
                $('<option/>')
                .attr('value',value)
                .append(label)
            );
        }

        $template
        .append(
            $('<div/>')
            .addClass('col-2')
            .append(window.translate('app.restaurant.show.tabs.info.billingForm.billingPeriods.begin'))
            .append(' ')
            .append($beginSelect)
        )
        .append(
            $('<div/>')
            .addClass('col-2')
            .append(window.translate('app.restaurant.show.tabs.info.billingForm.billingPeriods.end'))
            .append(' ')
            .append($endSelect)
        )
        .append(
            $('<div/>')
            .addClass('col')
            .append(window.translate('app.restaurant.show.tabs.info.billingForm.billingPeriods.levy'))
            .append(' ')
            .append($levySelect)
        );

        let $billingPeriodsLabel = $('<label/>')
        .attr('for','billingPeriods')
        .append(window.translate('app.restaurant.show.tabs.info.billingForm.billingPeriods.label'));
        let $billingPeriodsContainer = $('<div/>');

        if(this.restaurant.billingPeriods.length > 0){
            for(var i in this.restaurant.billingPeriods){
                let billingPeriod = this.restaurant.billingPeriods[i];

                let $clone = $template.clone();


                let $beginSelect = $('select[name="billingPeriods[][begin]"',$clone)
                .attr('name',"billingPeriods["+i+"][begin]");
                let $endSelect = $('select[name="billingPeriods[][end]"',$clone)
                .attr('name',"billingPeriods["+i+"][end]");
                let $levySelect = $('select[name="billingPeriods[][levy]"',$clone)
                .attr('name',"billingPeriods["+i+"][levy]");

                $('option[value="'+billingPeriod.begin+'"]',$beginSelect).attr('selected','selected');
                $('option[value="'+billingPeriod.end+'"]',$endSelect).attr('selected','selected');
                $('option[value="'+billingPeriod.levy+'"]',$levySelect).attr('selected','selected');

                $billingPeriodsContainer.append($clone);
            }
        }else{
            let $clone = $template.clone();

            let i = 0;
            let $beginSelect = $('select[name="billingPeriods[][begin]"',$clone)
            .attr('name',"billingPeriods["+i+"][begin]");
            let $endSelect = $('select[name="billingPeriods[][end]"',$clone)
            .attr('name',"billingPeriods["+i+"][end]");
            let $levySelect = $('select[name="billingPeriods[][levy]"',$clone)
            .attr('name',"billingPeriods["+i+"][levy]");

            $billingPeriodsContainer.append($clone);
        }

        let $btnAddPeriod = $('<button/>')
        .addClass('btn btn-sm btn-success btn-billingperiod-add')
        .append(window.translate('app.restaurant.show.tabs.info.billingForm.billingPeriods.add'))
        .on('click',function(event){
            event.stopPropagation();
            event.preventDefault();

            let $clone = $template.clone();

            let i = $('.restaurant-billingform-billingperiod-container').length;
            let $beginSelect = $('select[name="billingPeriods[][begin]"',$clone)
            .attr('name',"billingPeriods["+i+"][begin]");
            let $endSelect = $('select[name="billingPeriods[][end]"',$clone)
            .attr('name',"billingPeriods["+i+"][end]");
            let $levySelect = $('select[name="billingPeriods[][levy]"',$clone)
            .attr('name',"billingPeriods["+i+"][levy]");

            $billingPeriodsContainer.append($clone);
        })

        $box.append(
            $('<div/>')
            .addClass('form-group')
            .append($billingPeriodsLabel)
            .append($billingPeriodsContainer)
            .append(
                $('<div/>')
                .addClass('d-flex justify-content-center')
                .append($btnAddPeriod)
            )
        );


        //FIELD seller
        let $sellerLabel = $('<label/>')
        .attr('for','seller')
        .append(window.translate('app.restaurant.show.tabs.info.billingForm.seller.label'));
        this.$sellerSelect = $('<select/>')
        .attr('name','seller')
        .addClass('form-control')
        .attr('required','required')
        .append(
             $('<option/>')
             .val('')
             .append('-')
        );

        for(var i in this.sellers){
            let sellerItem = this.sellers[i];

            let value = sellerItem.node.id;
            let label = sellerItem.node.user.firstName + ' ' +  sellerItem.node.user.lastName;

            let $option = $('<option/>')
            .val(value)
            .append(label);

            if(this.restaurant.seller.id == value){
                $option.attr('selected','selected');
            }

            this.$sellerSelect.append($option);

        }
        $box.append(
            $('<div/>')
            .addClass('form-group')
            .append($sellerLabel)
            .append(this.$sellerSelect)
        );

    }

    buildSoftwareInputs($box){
        let $labelSoftware = $('<h3/>')
        .addClass('box-title')
        .append(window.translate('app.restaurant.show.tabs.info.softwareForm.label'))
        .appendTo($box);

        //FIELD applicationStatus
        let $applicationStatusLabel = $('<label/>')
        .attr('for','applicationStatus')
        .append(window.translate('app.restaurant.show.tabs.info.softwareForm.applicationStatus.label'));
        this.$applicationStatusSelect = $('<select/>')
        .attr('name','applicationStatus')
        .addClass('form-control')
        .append(
             $('<option/>')
             .val('')
             .append('-')
        );
        let applicationStatusOptions = [
            {
                'value': 1,
                'possiblesValues': [1],
                'label': window.translate('app.restaurant.show.tabs.info.softwareForm.applicationStatus.value.1')
            },
            {
                'value': 5,
                'possiblesValues': [2,5],
                'label': window.translate('app.restaurant.show.tabs.info.softwareForm.applicationStatus.value.5')
            },
            {
                'value': 6,
                'possiblesValues': [3,6],
                'label': window.translate('app.restaurant.show.tabs.info.softwareForm.applicationStatus.value.6')
            },
        ];
        for(var i in applicationStatusOptions){
            let option = applicationStatusOptions[i];

            let value = option.value;
            let label = option.label;

            let $option = $('<option/>')
            .val(value)
            .append(label);

            if(option.possiblesValues.includes(this.restaurant.applicationStatus)){
                $option.attr('selected','selected');
            }

            this.$applicationStatusSelect.append($option);
        }
        $box.append(
            $('<div/>')
            .addClass('form-group')
            .append($applicationStatusLabel)
            .append(this.$applicationStatusSelect)
        );



        //FIELD analyseDisplayMode
        let $analyseDisplayModeLabel = $('<label/>')
        .attr('for','analyseDisplayMode')
        .append(window.translate('app.restaurant.show.tabs.info.softwareForm.analyseDisplayMode.label'));
        let analyseDisplayModeValues = [1,2];
        let $analyseDisplayModeContainer = $('<div/>')
        .addClass('row');
        for(var v in analyseDisplayModeValues){
            let value = analyseDisplayModeValues[v];
            let label = window.translate('app.restaurant.show.tabs.info.softwareForm.analyseDisplayMode.value.'+value);

            let $inputRadio = $('<input/>')
            .attr('id','analyseDisplayMode'+value)
            .attr('type','radio')
            .attr('name','analyseDisplayMode')
            .val(value);

            if(value == this.restaurant.analyseDisplayMode){
                $inputRadio.attr('checked','checked');
            }

            let $labelRadio = $('<label/>')
            .attr('for','analyseDisplayMode'+value)
            .append(label);

            let $inputContainer = $('<div/>')
            .addClass('col')
            .append($inputRadio)
            .append(' ')
            .append($labelRadio);

            $analyseDisplayModeContainer.append($inputContainer);
        }
        $box.append(
            $('<div/>')
            .addClass('form-group')
            .append($analyseDisplayModeLabel)
            .append($analyseDisplayModeContainer)
        );

        //FIELD orderType
        let $orderTypeLabel = $('<label/>')
        .attr('for','orderType')
        .append(window.translate('app.restaurant.show.tabs.info.softwareForm.orderType.label'));
        let orderTypeValues = [1,2];
        let $orderTypeContainer = $('<div/>')
        .addClass('row');
        for(var v in orderTypeValues){
            let value = orderTypeValues[v];
            let label = window.translate('app.restaurant.show.tabs.info.softwareForm.orderType.value.'+value);

            let $inputRadio = $('<input/>')
            .attr('id','orderType'+value)
            .attr('type','radio')
            .attr('name','orderType')
            .val(value);

            if(value == this.restaurant.orderType){
                $inputRadio.attr('checked','checked');
            }

            let $labelRadio = $('<label/>')
            .attr('for','orderType'+value)
            .append(label);

            let $inputContainer = $('<div/>')
            .addClass('col')
            .append($inputRadio)
            .append(' ')
            .append($labelRadio);

            $orderTypeContainer.append($inputContainer);
        }
        $box.append(
            $('<div/>')
            .addClass('form-group')
            .append($orderTypeLabel)
            .append($orderTypeContainer)
        );

        //FIELD orderLimit
        let $orderLimitLabel = $('<label/>')
        .attr('for','orderLimit')
        .append(window.translate('app.restaurant.show.tabs.info.softwareForm.orderLimit.label'));
        let orderLimitValues = [1,2];
        let $orderLimitContainer = $('<div/>')
        .addClass('row');
        for(var v in orderLimitValues){
            let value = orderLimitValues[v];
            let label = window.translate('app.restaurant.show.tabs.info.softwareForm.orderLimit.value.'+value);

            let $inputRadio = $('<input/>')
            .attr('id','orderLimit'+value)
            .attr('type','radio')
            .attr('name','orderLimit')
            .val(value);

            if(value == this.restaurant.orderLimit){
                $inputRadio.attr('checked','checked');
            }

            let $labelRadio = $('<label/>')
            .attr('for','orderLimit'+value)
            .append(label);

            let $inputContainer = $('<div/>')
            .addClass('col')
            .append($inputRadio)
            .append(' ')
            .append($labelRadio);

            $orderLimitContainer.append($inputContainer);
        }
        $box.append(
            $('<div/>')
            .addClass('form-group')
            .append($orderLimitLabel)
            .append($orderLimitContainer)
        );

        //FIELD orderByMailStatus
        let $orderByMailStatusLabel = $('<label/>')
        .attr('for','orderByMailStatus')
        .append(window.translate('app.restaurant.show.tabs.info.softwareForm.orderByMailStatus.label'));
        let orderByMailStatusValues = [1,2];
        let $orderByMailStatusContainer = $('<div/>')
        .addClass('row');
        for(var v in orderByMailStatusValues){
            let value = orderByMailStatusValues[v];
            let label = window.translate('app.restaurant.show.tabs.info.softwareForm.orderByMailStatus.value.'+value);

            let $inputRadio = $('<input/>')
            .attr('id','orderByMailStatus'+value)
            .attr('type','radio')
            .attr('name','orderByMailStatus')
            .val(value);

            if(value == this.restaurant.orderByMailStatus){
                $inputRadio.attr('checked','checked');
            }

            let $labelRadio = $('<label/>')
            .attr('for','orderByMailStatus'+value)
            .append(label);

            let $inputContainer = $('<div/>')
            .addClass('col')
            .append($inputRadio)
            .append(' ')
            .append($labelRadio);

            $orderByMailStatusContainer.append($inputContainer);
        }
        $box.append(
            $('<div/>')
            .addClass('form-group')
            .append($orderByMailStatusLabel)
            .append($orderByMailStatusContainer)
        );

        //FIELD type
        let $typeLabel = $('<label/>')
        .attr('for','type')
        .append(window.translate('app.restaurant.show.tabs.info.softwareForm.type.label'));
        this.$typeSelect = $('<select/>')
        .attr('name','type')
        .addClass('form-control')
        .attr('required','required')
        .append(
             $('<option/>')
             .val('')
             .append('-')
        );
        let typeOptions = [
            {
                'value': 1,
                'possiblesValues': [1],
                'label': window.translate('app.restaurant.show.tabs.info.softwareForm.type.value.1')
            },
            {
                'value': 2,
                'possiblesValues': [2],
                'label': window.translate('app.restaurant.show.tabs.info.softwareForm.type.value.2')
            },
            {
                'value': 3,
                'possiblesValues': [3],
                'label': window.translate('app.restaurant.show.tabs.info.softwareForm.type.value.3')
            },
            {
                'value': 4,
                'possiblesValues': [4],
                'label': window.translate('app.restaurant.show.tabs.info.softwareForm.type.value.4')
            },
        ];
        for(var i in typeOptions){
            let option = typeOptions[i];

            let value = option.value;
            let label = option.label;

            let $option = $('<option/>')
            .val(value)
            .append(label);

            if(option.possiblesValues.includes(this.restaurant.type)){
                $option.attr('selected','selected');
            }

            this.$typeSelect.append($option);
        }
        $box.append(
            $('<div/>')
            .addClass('form-group')
            .append($typeLabel)
            .append(this.$typeSelect)
        );

        //FIELD preset
        let $presetLabel = $('<label/>')
        .attr('for','preset')
        .append(window.translate('app.restaurant.show.tabs.info.softwareForm.preset.label'));
        let presetValues = [1,0];
        let $presetContainer = $('<div/>')
        .addClass('row');
        for(var v in presetValues){
            let value = presetValues[v];
            let label = window.translate('app.restaurant.show.tabs.info.softwareForm.preset.value.'+value);

            let $inputRadio = $('<input/>')
            .attr('id','preset'+value)
            .attr('type','radio')
            .attr('name','preset')
            .val(value);

            if(value == this.restaurant.preset){
                $inputRadio.attr('checked','checked');
            }

            let $labelRadio = $('<label/>')
            .attr('for','preset'+value)
            .append(label);

            let $inputContainer = $('<div/>')
            .addClass('col')
            .append($inputRadio)
            .append(' ')
            .append($labelRadio);

            $presetContainer.append($inputContainer);
        }
        $box.append(
            $('<div/>')
            .addClass('form-group')
            .append($presetLabel)
            .append($presetContainer)
        );
    }

    buildContactCol(){
        let $col = $('<div/>')
        .addClass('col-4 p-2');

        let $box = $('<div/>')
        .addClass('white-box')
        .appendTo($col);

        let $label = $('<h3/>')
        .addClass('box-title')
        .append(window.translate('app.restaurant.show.tabs.info.contactForm.label'))
        .appendTo($box);

        //FIELD email
        let emails = this.restaurant.email.split(';');
        if(this.isCopy()){
            emails = [];
        }
        let $emailTemplate = $('<div/>')
        .addClass('mb-2')
        .addClass('restaurant-contactform-email-container')
        .append(
            $('<input/>')
            .attr('name','email[]')
            .attr('type','email')
            .addClass('form-control')
        );
        let $emailLabel = $('<label/>')
        .attr('for','email')
        .append(window.translate('app.restaurant.show.tabs.info.contactForm.email.label'));
        let $emailContainer = $('<div/>');

        if(emails.length > 0){

            for(var i in emails){
                let email = emails[i];

                let $clone = $emailTemplate.clone();


                let $input = $('input[name="email[]"',$clone);

                $input.val(email);

                $emailContainer.append($clone);
            }
        }else{
            let $clone = $emailTemplate.clone();
            $emailContainer.append($clone);

        }
        let $btnAddEmail = $('<button/>')
        .addClass('btn btn-sm btn-info btn-email-add')
        .append(
            $('<i/>')
            .addClass('fas fa-plus')
        )
        .on('click',function(event){
            event.stopPropagation();
            event.preventDefault();

            let $clone = $emailTemplate.clone();
            $emailContainer.append($clone);
        })

        $box.append(
            $('<div/>')
            .addClass('form-group')
            .append($emailLabel)
            .append($emailContainer)
            .append(
                $('<div/>')
                .addClass('d-flex justify-content-center')
                .append($btnAddEmail)
            )
        );



        //FIELD phone
        let $phoneLabel = $('<label/>')
        .attr('for','phone')
        .append(window.translate('app.restaurant.show.tabs.info.contactForm.phone.label'));
        let $phoneInput = $('<input/>')
        .attr('type','text')
        .attr('name','phone')
        .addClass('form-control')
        .val(this.restaurant.phone);
        $box.append(
            $('<div/>')
            .addClass('form-group')
            .append($phoneLabel)
            .append($phoneInput)
        )

        //FIELD website
        let $websiteLabel = $('<label/>')
        .attr('for','website')
        .append(window.translate('app.restaurant.show.tabs.info.contactForm.website.label'));
        let $websiteInput = $('<input/>')
        .attr('type','text')
        .attr('name','website')
        .addClass('form-control')
        .val(this.restaurant.info.website);
        $box.append(
            $('<div/>')
            .addClass('form-group')
            .append($websiteLabel)
            .append($websiteInput)
        )

        //FIELD linkedin
        let $linkedinLabel = $('<label/>')
        .attr('for','linkedin')
        .append(window.translate('app.restaurant.show.tabs.info.contactForm.linkedin.label'));
        let $linkedinInput = $('<input/>')
        .attr('type','text')
        .attr('name','linkedin')
        .addClass('form-control')
        .val(this.restaurant.info.linkedin);
        $box.append(
            $('<div/>')
            .addClass('form-group')
            .append($linkedinLabel)
            .append($linkedinInput)
        )

        //FIELD twitter
        let $twitterLabel = $('<label/>')
        .attr('for','twitter')
        .append(window.translate('app.restaurant.show.tabs.info.contactForm.twitter.label'));
        let $twitterInput = $('<input/>')
        .attr('type','text')
        .attr('name','twitter')
        .addClass('form-control')
        .val(this.restaurant.info.twitter);
        $box.append(
            $('<div/>')
            .addClass('form-group')
            .append($twitterLabel)
            .append($twitterInput)
        )

        //FIELD facebook
        let $facebookLabel = $('<label/>')
        .attr('for','facebook')
        .append(window.translate('app.restaurant.show.tabs.info.contactForm.facebook.label'));
        let $facebookInput = $('<input/>')
        .attr('type','text')
        .attr('name','facebook')
        .addClass('form-control')
        .val(this.restaurant.info.facebook);
        $box.append(
            $('<div/>')
            .addClass('form-group')
            .append($facebookLabel)
            .append($facebookInput)
        )

        //FIELD instagram
        let $instagramLabel = $('<label/>')
        .attr('for','instagram')
        .append(window.translate('app.restaurant.show.tabs.info.contactForm.instagram.label'));
        let $instagramInput = $('<input/>')
        .attr('type','text')
        .attr('name','instagram')
        .addClass('form-control')
        .val(this.restaurant.info.instagram);
        $box.append(
            $('<div/>')
            .addClass('form-group')
            .append($instagramLabel)
            .append($instagramInput)
        )

        return $col;
    }

}

module.exports = Form;

